module.exports = __webpack_public_path__ + "img/haiwaibuju-1.ae68a573.png";